import {
  Component, ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges, OnDestroy, OnInit,
  Output,
  signal,
  SimpleChanges,
  ViewChild, WritableSignal
} from '@angular/core';
import { SohoDataGridComponent } from 'ids-enterprise-ng';
import {LMFormatUtilService} from "@app/services";

@Component({
  selector:    'lm-facade-search-results',
  standalone: false,
  templateUrl: './lm-facade-search-results.component.html',
  styleUrl: './lm-facade-search-results.component.scss'
})
export class LMFacadeSearchResultsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() searchTerms: LMFacadeSearchEvent | undefined;
  @Input() businessObjects: Array<LMSearchBusinessObject> = [];
  @Input() templates: Array<LMFacadeReportTemplate> = [];

  private defaultShowDetails = false;
  showDetails = signal(this.defaultShowDetails);
  moduleCardWidth = signal(0);

  selectedBusinessObject: LMBusinessObject | undefined;
  selectedTemplate: LMFacadeReportTemplate | undefined;
  emptyModelSearchTitle = Soho.Locale.translate('Facade_BusinessObjectsEmptyMessage');
  emptyReportSearchTitle = Soho.Locale.translate('Facade_ReportTemplatesEmptyMessage');
  emptySearchInfo = Soho.Locale.translate('ReportCatalogEmptySearchMessage');


  private defaultTemplateDetail: LMFacadeDetailRequest = {
    type: 'undefined',
  };
  facadeDetailRequest: WritableSignal<LMFacadeDetailRequest> = signal(this.defaultTemplateDetail);
  @HostBinding('class.scrollable') scrollable = true;

  @ViewChild(SohoDataGridComponent) facadeDataGrid: SohoDataGridComponent | undefined;

  @Output() openModuleFacadeBC: EventEmitter<LMBusinessObject> = new EventEmitter<LMBusinessObject>();
  @Output() templateDetails: EventEmitter<boolean> = new EventEmitter<boolean>();

  private ro: ResizeObserver;
  private currentWidth = 0;

  private cardMargin = 20;

  constructor(
      private element: ElementRef
  ) {  }

  ngOnInit() {

    if (this.element.nativeElement) {
      this.ro = new ResizeObserver(() => {
        const newWidth = this.element.nativeElement.clientWidth;
        if (newWidth !== this.currentWidth) {
          this.currentWidth = newWidth;
          const newCardWidth = ((this.currentWidth - this.cardMargin)/2) - 1;
          this.moduleCardWidth.set(newCardWidth);
        }
      });

      this.ro.observe(this.element.nativeElement);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.searchTerms) {
      this.closeFieldsPanel();
    }
  }

  ngOnDestroy() {
    if (this.ro) {
      this.ro.unobserve(this.element.nativeElement);
    }
  }

  public closeFieldsPanel(): void {
    this.templateDetails.emit(false);
    this.showDetails.set(false);
  }

  onBusinessObjectClicked(businessObject: LMBusinessObject) {
    this.selectedBusinessObject = businessObject;
    this.selectedTemplate = undefined;
    this.openModuleFacadeBC.emit(this.selectedBusinessObject);
  }

  onTemplateClicked(template: LMFacadeReportTemplate) {
    this.showDetails.set(true);
    this.selectedTemplate = template;
    this.selectedBusinessObject = undefined;

    this.facadeDetailRequest.set({ type: 'template', detail: { template: template } });
    this.templateDetails.emit(true);
  }
}
